// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2DM4R","header":"ClearentDisclaimer_header__1RCUG","inner":"ClearentDisclaimer_inner__xTRcn"};